import { ButtonHTMLAttributes } from 'react';
import cx from 'classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: 'light' | 'dark';
  isMuted: boolean;
}

export function MuteButton({ theme = 'light', isMuted, className, ...props }: Props) {
  return (
    <button
      className={cx(
        'relative flex h-8 w-8 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-[#FF9446] active:opacity-70',
        theme === 'light'
          ? 'bg-[#003835] text-[#00D9B4]'
          : 'bg-[#00D9B4] text-[#003835]',
        className
      )}
      aria-label={isMuted ? 'Unmute video' : 'Mute video'}
      tabIndex={0}
      {...props}
    >
      {isMuted ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M3.63 3.63a1 1 0 0 0 0 1.41L7.29 8.7 7 9H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3l4 4a1 1 0 0 0 1.7-.7v-2.83l4.25 4.25a8 8 0 0 1-3.28 1.5 1 1 0 1 0 .5 1.93 10 10 0 0 0 4.4-2.1l1.22 1.22a1 1 0 0 0 1.41-1.41L5.05 3.63a1 1 0 0 0-1.42 0zM11 15.17L8.83 13H5v-2h2.83l.88-.88L11 12.46v2.71zm9-3.17a8.05 8.05 0 0 1-1.02 3.9l-1.46-1.46A6.02 6.02 0 0 0 18.9 12c0-2.68-1.67-4.97-4-5.91V4.18A8 8 0 0 1 20 12zm-4 0a4 4 0 0 1-.58 2.07l-1.5-1.5c.05-.18.08-.37.08-.57a3 3 0 0 0-1.5-2.6V7.44A4 4 0 0 1 16 12z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
        </svg>
      )}
    </button>
  );
}
